angular.module('mychart', [
    //third party
    'angularLocalStorage',
    'gettext',
    'headroom',
    'lodash',
    'ngAnimate',
    'ngTouch',
    'restangular',
    'toaster',
    'ui.bootstrap',
    'ui.router',


    //aprima
    'apEasyScroller',
    'account',
    'app',
    'mymessages',

    'aprima-core',
    'aprima-bridge',
    'aprima-config',
    'aprima-legacy-common',
    'aprima-provider-api',
    'aprima-patient-api'

]);

//todo move to WebCommon
angular.module('mychart').filter('tel', function () {
    'use strict';
    return function (tel) {
        if (!tel) {
            return '';
        }

        var value = tel.toString().trim().replace(/\D/g, '');

//        if (value.match(/[^0-9]/)) {
//            return tel;
//        }

        var country, city, number;

        switch (value.length) {
            case 10: // +1PPP####### -> C (PPP) ###-####
                country = 1;
                city = value.slice(0, 3);
                number = value.slice(3);
                break;

            case 11: // +CPPP####### -> CCC (PP) ###-####
                country = value[0];
                city = value.slice(1, 4);
                number = value.slice(4);
                break;

            case 12: // +CCCPP####### -> CCC (PP) ###-####
                country = value.slice(0, 3);
                city = value.slice(3, 5);
                number = value.slice(5);
                break;

            case 13: // (CCC)###-#### -> (PPP) ###-####
                return value.slice(0, 5) + ' ' + value.slice(5);

            default:
                return tel;
        }

        if (country === 1) {
            country = '';
        }

        number = number.slice(0, 3) + '-' + number.slice(3);

        return (country + ' (' + city + ') ' + number).trim();
    };
});